<template>
  <oa-modal :name="name" >

    <template slot="header">
      <img class="ut-mr-4 ut--mb-2" src="@/assets/images/pause.svg"/>
      <span>Place lead on hold</span>
    </template>

    <template slot="description">
      While the lead is on hold, it will be removed from your active lead list.
      Set a follow up date so we can remind you when to get back in touch with the vendor
    </template>

    <template slot="body">
      <div class="form-group">
        <label for="off-hold-date" >Place on hold until</label>
        <oa-datepicker v-model="currentOffHoldDate" :disabledDates="disabledDates" />
      </div>
    </template>

    <template slot="error">
      <span v-if="errorMsg !== ''" id="error-message" class="error inline">
        {{ errorMsg }}
      </span>
    </template>

    <template slot="footer">
      <div>
        <button class="btn btn-green" :disabled="offHoldDate === ''" @click="placeOnHold">
          Confirm
        </button>
        <button class="btn btn-small white-bg ut-ml-4" @click="$modal.hide(name)">
          Cancel
        </button>
      </div>
    </template>

  </oa-modal>
</template>

<script>
import OaModal from '@/components/Modals/OaModal.vue';
import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import OaDatepicker from '@/components/Forms/OaDatepicker';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'OnHoldModal',
  components: { OaModal, OaDatepicker },
  computed: {
    ...mapState({
      lam: state => state.leadAgentMappingStore.lam,
      user: state => state.userStore.user,
      lead: state => state.leadAgentMappingStore.lead,
      agentExperiments: state => state.experimentStore.agentExperiments,
    }),
    currentOffHoldDate: {
      get() {
        if (this.$helpers.isValidDate(this.lam.lamoffholddatetime) && this.offHoldDate === '') {
          return this.$helpers.formatDate(this.lam.lamoffholddatetime);
        }
        return this.offHoldDate;
      },
      set(value) {
        value.setHours(0);
        value.setMinutes(0);
        value.setSeconds(0);
        value.setMilliseconds(0);
        console.log(value);
        this.offHoldDate = value;
      },
    },
  },
  data() {
    return {
      name: 'on-hold-modal',
      offHoldDate: '',
      errorMsg: '',
      disabledDates: {
        to: moment().subtract(1, 'days').toDate(),
      },
    };
  },
  methods: {
    closeModal() {
      this.resetFormView();
      this.$modal.hide(this.name);
    },
    resetFormView() {
      this.offHoldDate = '';
      this.errorMsg = '';
    },
    setError(msg) {
      if (this.errorMsg.length === 0) {
        this.errorMsg = msg;
      }
    },
    placeOnHold() {
      if (this.offHoldDate != null && this.offHoldDate !== '') {
        const payload = {
          lamid: this.lam.id,
          data: {
            statetypeid: LeadAgentLeadStateType.On_Hold,
            lamoffholddatetime: this.$helpers.convertToUTC(this.offHoldDate, 'YYYY-MM-DD HH:mm:ss'),
            oauserid: !!this.user ? this.user.id : '',
            oauserkey: !!this.user ? this.user.key : '',
          },
        };
        this.$store
          .dispatch('leadAgentMappingStore/updateLeadAgentMapping', payload)
          .then(() => {
            this.closeModal();
            window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrolls to the top of the page
          })
          .catch((err) => {
            // Probably want to do something :)
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped>

</style>
